var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panels",
    [
      _c(
        "v-expansion-panel",
        [
          _c("v-expansion-panel-header", [_vm._v("Настройки SEO")]),
          _c(
            "v-expansion-panel-content",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "span",
                        [
                          _vm._v("Meta title ("),
                          _c("TranslationIcon"),
                          _vm._v(")"),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: { outlined: "", disabled: _vm.loading },
                        model: {
                          value: _vm.fields.seoMetaTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.fields, "seoMetaTitle", $$v)
                          },
                          expression: "fields.seoMetaTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "span",
                        [
                          _vm._v("Description ("),
                          _c("TranslationIcon"),
                          _vm._v(")"),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: { outlined: "", disabled: _vm.loading },
                        model: {
                          value: _vm.fields.seoMetaDescription,
                          callback: function ($$v) {
                            _vm.$set(_vm.fields, "seoMetaDescription", $$v)
                          },
                          expression: "fields.seoMetaDescription",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "span",
                        [
                          _vm._v("Keywords ("),
                          _c("TranslationIcon"),
                          _vm._v(")"),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: { outlined: "", disabled: _vm.loading },
                        model: {
                          value: _vm.fields.seoMetaKeywords,
                          callback: function ($$v) {
                            _vm.$set(_vm.fields, "seoMetaKeywords", $$v)
                          },
                          expression: "fields.seoMetaKeywords",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("span", [_vm._v("SEO disallow index")]),
                      _c("v-switch", {
                        attrs: {
                          inset: "",
                          dense: "",
                          disabled: _vm.loading,
                          loading: _vm.loading,
                        },
                        model: {
                          value: _vm.fields.seoDisallowIndex,
                          callback: function ($$v) {
                            _vm.$set(_vm.fields, "seoDisallowIndex", $$v)
                          },
                          expression: "fields.seoDisallowIndex",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("span", [_vm._v("Rel canonical")]),
                      _c("v-text-field", {
                        attrs: { outlined: "", disabled: _vm.loading },
                        model: {
                          value: _vm.fields.seoRelCanonical,
                          callback: function ($$v) {
                            _vm.$set(_vm.fields, "seoRelCanonical", $$v)
                          },
                          expression: "fields.seoRelCanonical",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("span", [_vm._v("SEO image")]),
                      _c("MediaFilePicker", {
                        attrs: {
                          multiple: false,
                          "file-type": _vm.$options.mediaTypesByKeys.IMAGE,
                          value: _vm.fields.seoOgImageId,
                        },
                        on: { change: _vm.filesHandler },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }